import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { formatHTML } from '../utils';

export default class CursoModuloCellphone extends Component {
  constructor(props){
    super(props);
    this.state = {
      mostrar_descripcion: false
    };

    this.showHideDescription = this.showHideDescription.bind(this);
  }

  showHideDescription(){
    this.setState(
      { mostrar_descripcion: !this.state.mostrar_descripcion }
    );
  }

  render(){
    let modulo = this.props.modulo;
    return (
      <tr>
        <th className='modulo-description-cellphone'>
          {modulo.nombre}
          {modulo.completado!==undefined?<span className="badge badge-info">{modulo.completado}%</span>:""}
          <br/>
          <div className='btn-group font-weight-normal'>
            <button className="btn btn-light" onClick={this.showHideDescription}>
              Descripción
            </button>
            { this.props.adquirido ? <Link to={`/classroom/${modulo.id}`} className="btn btn-primary">Entrar</Link> : "" }
          </div>
          {
            this.state.mostrar_descripcion ?
            <div className="descripcion-curso font-weight-normal">
              <hr />
              {formatHTML(modulo.descripcion)}
            </div> :
            ""
          }
        </th>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/curso-modulo-cellphone.js